module.exports = __webpack_public_path__ + "img/group_remove_opsz20.7663c350.svg";